<header-web (dataEvent)='setLanguage($event)'></header-web>
<div class="container-fluid body-m">
  <div class="row">
    <div class="col-6 offset-3">
      <div class="container text-center">
        <h2 class="title fw-bold text-rojo">GALILEO - ERP MOVIL</h2>
        <p class="text-justify text fw-bold text-lago lh-1 mb-2">Lorem ipsum dolor sit amet consectetur adipisicing
          elit. Voluptates maiores voluptatem nisi odit nesciunt corrupti autem dolores? Est, quos voluptatum.</p>
        <p class="text-justify text fw-bold text-lago lh-1">Lorem ipsum dolor sit amet consectetur adipisicing elit.
          Dolore at dignissimos molestiae ipsam, voluptatem placeat laborum consequuntur quidem minus ea.</p>
      </div>
    </div>
    <div class="col-12 my-5">
      <div class="row d-flex align-items-center">
        <div class="col-5 px-0">
          <div class="carousel"
            data-flickity='{ "bgLazyLoad": 1, "autoPlay": true, "wrapAround": false, "fullscreen": true }'>
            <img src="../../assets/image/movil/pedidos-1.jpg" class="carousel-cell" alt="">
            <img src="../../assets/image/movil/pedidos-2.jpg" class="carousel-cell" alt="">
            <img src="../../assets/image/movil/pedidos-3.jpg" class="carousel-cell" alt="">
            <!-- <div class="carousel-cell" data-flickity-bg-lazyload="https://unsplash.it/480/645/?random"></div>
            <div class="carousel-cell" data-flickity-bg-lazyload="https://unsplash.it/480/646/?random"></div> -->
          </div>
        </div>
        <div class="col-7">
          <div class="container p-4">
            <h3 class="text-lago text-center title fw-bold">SISTEMA MOVIL PARA FACTURACIÓN</h3>
            <p class="subtitle fw-bold text-rojo">¿Eres distribuidor mayorista o minorista? Si tu punto de venta genera colas largas para tus clientes, puedes vender y generar comprobantes desde tu celular.</p>
            <ul class="text fw-bold list-center text-rojo">
              <li>Buscador inteligente de productos, si cuentas con mas de 1000 productos, con solo una palabra podrás buscar y encontrar el producto que desees.</li>
              <li>Si tienes una devolución de tus productos ¡Descuida! Podrás anular las transacciones y comprobantes desde el mismo dispositivo.</li>
              <li>Observaciones adicionales, podrás agregar comentarios de tus clientes en tus productos para una atención optima.</li>
              <li>Podrás vender desde cualquier parte, pero mejor aún, desde tu dispositivo móvil.</li>
              <li>Generación y consulta de comprobantes electrónicos (Boletas, Facturas).</li>
              <li>Especializado para venta itinerante.</li>
              <li>Detalle de precio y stock actual de inventario.</li>
            </ul>
            <div class="row mt-4">
              <div class="col-6 px-0">
                <div class="card border-0 bg-pantano">
                  <div class="card-body">
                    <h5 class="text-center title text-naranja">INSTALACIÓN </h5>
                    <p class="text-justify text fw-bold text-humo lh-sm">Lorem ipsum dolor sit amet consectetur
                      adipisicing elit. Officia aut repudiandae labore, asperiores sint, praesentium consectetur cum
                      repellendus aperiam assumenda tempora voluptas omnis modi et, inventore corrupti pariatur alias
                      animi.</p>
                  </div>
                </div>
              </div>
              <div class="col-6 px-0">
                <div class="card border-0 bg-humo">
                  <div class="card-body">
                    <h5 class="text-center title text-naranja">SOPORTE</h5>
                    <p class="text-justify text text-lago lh-sm fw-bold">Lorem ipsum dolor sit amet consectetur
                      adipisicing elit. Officia aut repudiandae labore, asperiores sint, praesentium consectetur cum
                      repellendus aperiam assumenda tempora voluptas omnis modi et, inventore corrupti pariatur alias
                      animi.</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-12 my-5">
      <div class="row d-flex align-items-center">
        <div class="col-7">
          <div class="container p-3">
            <h3 class="text-lago text-center title fw-bold">SISTEMA MOVIL PARA RESTAURANTES</h3>
            <p class="subtitle fw-bold text-rojo">Con el sistema móvil tomar pedidos ya no será un problema. Las comandas móviles le permitirán generar ordenes de pedidos directamente a cocina/barra desde un celular o Tablet.</p>
            <ul class="text fw-bold list-center text-rojo">
              <li>Panel de lista de pedidos, donde podrás observar todos los pedidos realizados antes de generar la orden en cocina/barra.</li>
              <li>Cada mozo tendrá un usuario para la atención, por lo que podrás controlar la cantidad de mesas atendidas por mozo.</li>
              <li>Controla el estado de los pedidos, veras si están pendientes de atención, atendidos o cancelados.</li>
              <li>El panel de mesas te permitirá diferenciar que mesas están ocupadas y que mesas están libres.</li>
              <li>Agrega observaciones a tus pedidos. ¡Algunos clientes no quieren el ceviche con picante!</li>
              <li>El sistema móvil cuenta con una carta virtual interactiva para la toma de pedidos.</li>
              <li>Podrás ver el precio de tus platos y modificar la cantidad.</li>
            </ul>
            <div class="row mt-3">
              <div class="col-6 px-0">
                <div class="card border-0 bg-pantano">
                  <div class="card-body">
                    <h5 class="text-center title text-naranja">INSTALACIÓN</h5>
                    <p class="text-justify text fw-bold text-humo lh-sm">Lorem ipsum dolor sit amet consectetur
                      adipisicing elit. Officia aut repudiandae labore, asperiores sint, praesentium consectetur cum
                      repellendus aperiam assumenda tempora voluptas omnis modi et, inventore corrupti pariatur alias
                      animi.</p>
                  </div>
                </div>
              </div>
              <div class="col-6 px-0">
                <div class="card border-0 bg-humo">
                  <div class="card-body">
                    <h5 class="text-center title text-naranja">SOPORTE</h5>
                    <p class="text-justify text text-lago lh-sm fw-bold">Lorem ipsum dolor sit amet consectetur
                      adipisicing elit. Officia aut repudiandae labore, asperiores sint, praesentium consectetur cum
                      repellendus aperiam assumenda tempora voluptas omnis modi et, inventore corrupti pariatur alias
                      animi.</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-5 px-0">
          <div class="carousel"
            data-flickity='{ "bgLazyLoad": 1, "autoPlay": true, "wrapAround": false, "fullscreen": true }'>
            <img src="../../assets/image/movil/restaurante-1.jpg" class="carousel-cell" alt="">
            <img src="../../assets/image/movil/restaurante-2.jpg" class="carousel-cell" alt="">
            <img src="../../assets/image/movil/restaurante-3.jpg" class="carousel-cell" alt="">
            <img src="../../assets/image/movil/restaurante-4.jpg" class="carousel-cell" alt="">
            <img src="../../assets/image/movil/restaurante-5.jpg" class="carousel-cell" alt="">
            <img src="../../assets/image/movil/restaurante-6.jpg" class="carousel-cell" alt="">
            <!-- <div class="carousel-cell" data-flickity-bg-lazyload="https://unsplash.it/480/645/?random"></div>
            <div class="carousel-cell" data-flickity-bg-lazyload="https://unsplash.it/480/646/?random"></div> -->
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<footer-web></footer-web>
